/* Kopstorm Wave 14: native hero slider (W142). Swipe, arrows, dots and a
   gentle autoplay that pauses on hover, focus and hidden tabs. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.kop14Ready) return;
    root.dataset.kop14Ready = '1';
    var track = root.querySelector('[data-kop14-track]');
    if (!track) return;
    var slides = track.children;
    var dots = root.querySelectorAll('[data-kop14-dot]');
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;
    var current = 0;

    function go(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      fit();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === current); });
      restartBar();
      /* While the slider scrolls to the new slide, ignore scroll position
         updates; otherwise the previous dot is marked active for a moment
         and its progress bar flashes back to the start. */
      lock = true;
      if (lockTimer) clearTimeout(lockTimer);
      lockTimer = setTimeout(function () { lock = false; }, 700);
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    }
    var lock = false, lockTimer = null;
    track.addEventListener('scrollend', function () {
      if (!lock) return;
      lock = false;
      if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
    });
    function fit() {
      /* Height now comes from CSS: on mobile every slide stretches to the
         tallest one, so the page never jumps while a visitor swipes. */
      track.style.height = '';
    }
    function sync() {
      if (lock) return;
      var w = track.clientWidth || 1;
      var next = Math.round(track.scrollLeft / w);
      if (next !== current) current = next;
      dots.forEach(function (d, n) {
        if (n === current) { if (!d.classList.contains('is-active')) d.classList.add('is-active'); }
        else d.classList.remove('is-active');
      });
    }
    function restartBar() {
      /* Restart the W142c progress bar on the active dot so it lines up with the timer. */
      var d = dots[current];
      if (!d) return;
      d.classList.remove('is-active');
      void d.offsetWidth;
      d.classList.add('is-active');
    }
    /* Timer with pause and resume. A tap, hover or focus only pauses the
       progress bar where it is and continues the remaining time afterwards;
       the bar starts from zero only when the slide actually changes. */
    var auto = delay > 0 && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var remaining = delay * 1000, startedAt = 0, paused = false;
    function clear() { if (timer) { clearTimeout(timer); timer = null; } }
    function run() {
      clear();
      startedAt = Date.now();
      timer = setTimeout(function () { go(current + 1); start(); }, Math.max(remaining, 50));
    }
    function start() {
      /* Fresh cycle on the current slide */
      clear();
      paused = false;
      root.classList.remove('is-paused');
      if (!auto) { root.classList.add('is-static'); return; }
      root.classList.remove('is-static');
      remaining = delay * 1000;
      restartBar();
      run();
    }
    function stop() {
      if (!auto || paused) return;
      clear();
      paused = true;
      remaining -= Date.now() - startedAt;
      root.classList.add('is-paused');
    }
    function resume() {
      if (!auto || !paused) return;
      paused = false;
      root.classList.remove('is-paused');
      run();
    }

    var touching = false, settle = null, downSlide = 0;
    function afterMove() {
      /* Same slide: continue where the bar was. New slide: start fresh. */
      if (current !== downSlide) start(); else resume();
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
      if (touching) return;
      if (settle) clearTimeout(settle);
      settle = setTimeout(function () { settle = null; if (paused) afterMove(); }, 160);
    }, { passive: true });
    /* Autoplay never fires while a finger is on the slider, otherwise the
       programmatic scroll fights the swipe and the slide jumps back */
    function down() { touching = true; lock = false; downSlide = current; stop(); }
    function up() {
      touching = false;
      if (settle) clearTimeout(settle);
      settle = setTimeout(function () { settle = null; afterMove(); }, 400);
    }
    track.addEventListener('touchstart', down, { passive: true });
    track.addEventListener('touchend', up, { passive: true });
    track.addEventListener('touchcancel', up, { passive: true });
    var prev = root.querySelector('[data-kop14-prev]');
    var next = root.querySelector('[data-kop14-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); start(); });
    if (next) next.addEventListener('click', function () { go(current + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-kop14-dot'), 10)); start(); });
    });
    /* Real mouse only: phones fire emulated mouse events after a tap */
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stop(); });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resume(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) resume(); });
    root.addEventListener('focusin', function (e) { if (e.target.matches(':focus-visible')) stop(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else resume(); });
    fit();
    start();
  }
  /* W145 signup deck: every few seconds the front card steps aside and the
     next kit comes forward. Pauses on hover, hidden tabs and reduced motion. */
  function deck(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kop14-card]'));
    if (!cards.length) return;
    var order = cards.slice();
    function paint() {
      order.forEach(function (card, n) {
        card.setAttribute('data-pos', n < 3 ? String(n + 1) : '0');
      });
    }
    paint();
    var ms = (parseInt(root.getAttribute('data-interval'), 10) || 4) * 1000;
    if (cards.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var timer = null;
    function tick() { order.push(order.shift()); paint(); }
    function start() { stop(); timer = setInterval(tick, ms); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var band = root.closest('.kop14-signup__band') || root;
    band.addEventListener('mouseenter', stop);
    band.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  }
  /* W145 signup: submit without a page reload, to Klaviyo when a public key
     and list ID are set, otherwise to Shopify's newsletter form. */
  function signup(form) {
    if (form.dataset.kop14Ready) return;
    form.dataset.kop14Ready = '1';
    var row = form.querySelector('[data-kop14-signup-row]');
    var ok = form.querySelector('[data-kop14-signup-success]');
    var err = form.querySelector('[data-kop14-signup-error]');
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    if (!row || !ok || !input) return;
    var key = (form.getAttribute('data-klaviyo-key') || '').trim();
    var list = (form.getAttribute('data-klaviyo-list') || '').trim();
    var source = form.getAttribute('data-klaviyo-source') || 'Homepage builders club';

    function done() {
      row.hidden = true;
      if (err) err.hidden = true;
      ok.hidden = false;
      try { form.dispatchEvent(new CustomEvent('kopstorm:signup', { bubbles: true, detail: { source: source } })); } catch (e) {}
    }
    function toKlaviyo(email) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
    }
    function toShopify() {
      return fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          /* Shopify sends spam checks to /challenge; that needs the real page. */
          if (!r.ok || (r.url && r.url.indexOf('/challenge') > -1)) throw new Error('shopify');
        });
    }

    form.addEventListener('submit', function (event) {
      var email = (input.value || '').trim();
      if (!email || !input.checkValidity()) return;
      event.preventDefault();
      if (button) button.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;
      /* Never reload the page. Klaviyo first when configured; if that fails
         (ad blocker, network) the address still goes to Shopify's list in
         the background, and the visitor always gets the code on the page. */
      var send = key && list ? toKlaviyo(email) : toShopify();
      send.then(done).catch(function (e) {
        try { console.warn('[Kopstorm signup] first attempt failed', e); } catch (x) {}
        var retry = key && list ? toShopify() : Promise.reject(e);
        retry.catch(function (e2) {
          try { console.warn('[Kopstorm signup] Shopify fallback failed', e2); } catch (x) {}
        });
        if (button) button.removeAttribute('aria-busy');
        done();
      });
    });
  }

  /* W141 review row on mobile: arrows step one card, and dim at the ends. */
  function proofSlider(root) {
    if (root.dataset.kop14Ready) return;
    root.dataset.kop14Ready = '1';
    var track = root.querySelector('[data-kop14-proof-track]');
    var prev = root.querySelector('[data-kop14-proof-prev]');
    var next = root.querySelector('[data-kop14-proof-next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function state() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(state); }, { passive: true });
    window.addEventListener('resize', state);
    state();
  }

  function boot() {
    document.querySelectorAll('.kop14-hero').forEach(init);
    document.querySelectorAll('[data-kop14-deck]').forEach(deck);
    document.querySelectorAll('[data-kop14-signup-form]').forEach(signup);
    document.querySelectorAll('[data-kop14-proof]').forEach(proofSlider);
    document.querySelectorAll('[data-kop14-copy]').forEach(function (btn) {
      if (btn.dataset.kop14Ready) return;
      btn.dataset.kop14Ready = '1';
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-kop14-copy');
        var show = function () {
          btn.textContent = btn.getAttribute('data-copied') || label;
          setTimeout(function () { btn.textContent = label; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(show, show);
        else show();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
